import React from "react";
import {
  FaArrowDown,
  FaBoxes,
  FaCheckCircle,
  FaExclamationTriangle,
  FaPlus,
  FaWarehouse,
} from "react-icons/fa";
import { FaThumbsUp } from "react-icons/fa6";

// Sample inventory data

const InvenKpiAndAlertTable = ({ data, station }) => {
  const tempDivIItem = data.filter((f) => f.station_code === station);

  const totalItems = tempDivIItem.length;

  const totalQuantity = tempDivIItem.reduce(
    (sum, item) => sum + item.total_qty,
    0,
  );
  const defectiveItem = tempDivIItem.reduce(
    (sum, item) => sum + item.defective_qty,
    0,
  );
  const required = tempDivIItem.reduce(
    (sum, item) => sum + item.required_qty,
    0,
  );

  const outOfStock = tempDivIItem.filter((item) => item.total_qty === 0);
  const surPlusItems = tempDivIItem.filter(
    (item) => item.surplus_short_qty > 0,
  );

  return (
    <div>
      {/* ================= KPI CARDS ================= */}
      <div className="row g-3 mb-4">
        {/* Total Items */}
        <div className="col-12 col-sm-6 col-xl">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <p className="text-muted small mb-1">Total Items</p>

                  <h3 className="fw-bold mb-1">{totalItems}</h3>

                  <small className="text-success">
                    <FaCheckCircle className="me-1" />
                    Active inventory
                  </small>
                </div>

                <div className="bg-primary bg-opacity-10 text-primary rounded-3 p-3">
                  <FaBoxes size={24} />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Total Quantity */}
        <div className="col-12 col-sm-6 col-xl">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <p className="text-muted small mb-1">Total Stock</p>

                  <h3 className="fw-bold mb-1">
                    {totalQuantity.toLocaleString()}
                  </h3>

                  <small className="text-muted">Across all category</small>
                </div>

                <div className="bg-success bg-opacity-10 text-success rounded-3 p-3">
                  <FaWarehouse size={24} />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Required Stock */}
        <div className="col-12 col-sm-6 col-xl">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <p className="text-muted small mb-1">Surplus /short Stock </p>

                  <h3 className="fw-bold mb-1">
                    {surPlusItems.length}/
                    {tempDivIItem.length - surPlusItems.length}
                  </h3>

                  <small
                    className={
                      surPlusItems.length === 0
                        ? "text-success"
                        : "text-warning"
                    }
                  >
                    {surPlusItems.length === 0 ? (
                      <FaThumbsUp className="me-1" />
                    ) : (
                      <FaExclamationTriangle className="me-1" />
                    )}
                    {surPlusItems.length === 0
                      ? "Enough Stock"
                      : "Needs attention"}{" "}
                  </small>
                </div>

                <div
                  className={`${surPlusItems.length === 0 ? "text-success bg-success" : "text-warning bg-warning  "} bg-opacity-10  rounded-3 p-3`}
                >
                  {surPlusItems.length === 0 ? (
                    <FaThumbsUp size={24} />
                  ) : (
                    <FaExclamationTriangle size={24} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
        {/* Low Stock */}
        <div className="col-12 col-sm-6 col-xl">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <p className="text-muted small mb-1">
                    Total Defective Stock{" "}
                  </p>

                  <h3 className="fw-bold mb-1">{defectiveItem}</h3>

                  <small className="text-warning">
                    <FaExclamationTriangle className="me-1" />
                    Needs attention
                  </small>
                </div>

                <div className="bg-warning bg-opacity-10 text-warning rounded-3 p-3">
                  <FaExclamationTriangle size={24} />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Out of Stock */}
        <div className="col-12 col-sm-6 col-xl">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start gap-3">
                {/* Content */}
                <div className="flex-grow-1 min-width-0">
                  <p className="text-muted small mb-1">Out of Stock</p>

                  {outOfStock.length === 0 ? (
                    <h3 className="fw-bold mb-1">0</h3>
                  ) : (
                    <div
                      className=" mb-1"
                      style={{
                        overflowWrap: "anywhere",
                        wordBreak: "break-word",
                        // lineHeight: "1.4",
                      }}
                    >
                      {outOfStock.map((os, index) => (
                        <span key={index}>
                          {os.item_name}
                          {index < outOfStock.length - 1 && ", "}
                        </span>
                      ))}
                    </div>
                  )}

                  <small className="text-danger d-block">
                    {outOfStock.length === 0 ? (
                      ""
                    ) : (
                      <>
                        <FaArrowDown className="me-1" />
                        Immediate action
                      </>
                    )}
                  </small>
                </div>

                {/* Icon */}
                <div className="bg-danger bg-opacity-10 text-danger rounded-3 p-3 flex-shrink-0">
                  <FaArrowDown size={24} />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*Pending Order */}
        <div className="col-12 col-sm-6 col-xl">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start gap-3">
                {/* Content */}
                <div className="flex-grow-1 min-width-0">
                  <p className="text-muted small mb-1">
                    Pending Purchased Stock
                  </p>

                  <h3 className="fw-bold mb-1">0</h3>

                  <small className=" text-success d-block">
                    <FaPlus className="me-1" />
                    About to add new stocks
                  </small>
                </div>

                {/* Icon */}
                <div className="bg-success bg-opacity-10 text-success rounded-3 p-3 flex-shrink-0">
                  <FaPlus size={24} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= SUMMARY ROW ================= */}
      <div className="row g-3 mb-4">
        {/* Stock Status */}

        {/* Stock Status */}
        <div className="col-lg-2">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body d-flex flex-column">
              <h6 className="fw-bold mb-3">Stock Status</h6>

              {/* Stock Items Container */}
              <div className="d-flex flex-column flex-grow-1 justify-content-between">
                {/* In Stock */}
                <div className="flex-grow-1 d-flex flex-column justify-content-center">
                  <div className="d-flex justify-content-between mb-1">
                    <span className="small">In Stock</span>
                    <span className="small fw-semibold">{totalQuantity}</span>
                  </div>

                  <div className="progress" style={{ height: "7px" }}>
                    <div
                      className="progress-bar bg-success"
                      style={{
                        width: `${
                          (totalQuantity / (totalQuantity + required)) * 100
                        }%`,
                      }}
                    />
                  </div>
                </div>
                {/* Required Qty */}
                <div className="flex-grow-1 d-flex flex-column justify-content-center">
                  <div className="d-flex justify-content-between mb-1">
                    <span className="small">Surplus Item </span>
                    <span className="small fw-semibold">
                      {surPlusItems.length}
                    </span>
                  </div>

                  <div className="progress" style={{ height: "7px" }}>
                    <div
                      className="progress-bar bg-primary"
                      style={{
                        width: `${
                          (surPlusItems.length / tempDivIItem.length) * 100
                        }%`,
                      }}
                    />
                  </div>
                </div>{" "}
                <div className="flex-grow-1 d-flex flex-column justify-content-center">
                  <div className="d-flex justify-content-between mb-1">
                    <span className="small">Shot Item</span>
                    <span className="small fw-semibold">
                      {tempDivIItem.length - surPlusItems.length}
                    </span>
                  </div>

                  <div className="progress" style={{ height: "7px" }}>
                    <div
                      className="progress-bar bg-warning"
                      style={{
                        width: `${
                          ((tempDivIItem.length - surPlusItems.length) /
                            tempDivIItem.length) *
                          100
                        }%`,
                      }}
                    />
                  </div>
                </div>
                {/* Defective Stock */}
                <div className="flex-grow-1 d-flex flex-column justify-content-center">
                  <div className="d-flex justify-content-between mb-1">
                    <span className="small">Defective Stock</span>
                    <span className="small fw-semibold">{defectiveItem}</span>
                  </div>

                  <div className="progress" style={{ height: "7px" }}>
                    <div
                      className="progress-bar bg-danger"
                      style={{
                        width: `${
                          (defectiveItem / (totalQuantity + required)) * 100
                        }%`,
                      }}
                    />
                  </div>
                </div>
                {/* Out of Stock */}
                <div className="flex-grow-1 d-flex flex-column justify-content-center">
                  <div className="d-flex justify-content-between mb-1">
                    <span className="small">Out of Stock</span>
                    <span className="small fw-semibold">
                      {outOfStock.length}
                    </span>
                  </div>

                  <div className="progress" style={{ height: "7px" }}>
                    <div
                      className="progress-bar bg-danger"
                      style={{
                        width: `${
                          (outOfStock.length / tempDivIItem.length) * 100
                        }%`,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Low Stock Items */}
        <div className="col-lg">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-bold mb-0">Low Stock Alerts</h6>

                <span className="badge bg-warning text-dark">
                  {
                    tempDivIItem.filter(
                      (item) => item.total_qty <= item.required_qty / 4,
                    ).length
                  }{" "}
                  Items
                </span>
              </div>

              <div className="table-responsive">
                <table className="table table-sm align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Available</th>
                      <th>Required Qty</th>
                      <th>Last Transaction</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {tempDivIItem
                      .filter((item) => item.total_qty <= item.required_qty / 4)
                      .sort((a, b) => a.total_qty - b.total_qty)
                      .map((item) => (
                        <tr key={item.id}>
                          <td>
                            <div className="fw-semibold">{item.item_name}</div>

                            {/* <small className="text-muted">
                              {item.total_qty}
                            </small> */}
                          </td>

                          <td>{item.total_qty}</td>

                          <td className="fw-semibold">{item.required_qty}</td>

                          <td>
                            <div className="fw-semibold">
                              {item.last_transaction_date?.slice(0, 10) || "-"}
                            </div>

                            <small className="text-muted">
                              {item.last_transaction_date?.slice(12, 19)}
                            </small>
                          </td>

                          <td>
                            <span
                              className={`badge ${
                                item.total_qty === 0
                                  ? "bg-danger"
                                  : "bg-warning text-dark"
                              }`}
                            >
                              {item.total_qty === 0
                                ? "Out of Stock"
                                : "Low Stock"}
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InvenKpiAndAlertTable;
